<app-label-configuration
  [title]="'P00080.installation.misenoeuvrerx.regulation' | translate"
  [titleListe]="
    'P00080.installation.misenoeuvrerx.regulation.redox' | translate
  "
  [value]="actionStack!.getValue('alCConsigneRX')"
  [liste]="P00080ConsignRX()"
  [information]="P00080InstallationCl"
  (onPress)="
    actionStack!.editValue(
      P00039DataRxTxIndex.Altimeo_Control,
      'alCConsigneRX',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

@if (
  hasProduitP0003600() > 0 ||
  hasProduitP0003601() > 0 ||
  hasProduitP0004700() > 0 ||
  hasProduitP00046() > 0 ||
  hasProduitP00058() > 0 ||
  hasProduitP0006600() > 0
) {
  <app-switch-configuration
    [nameCustom]="'P00080.installation.filtration.value' | translate"
    [value]="actionStack!.getValue('alIActivationAutoMaintienRX') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Altimeo_Installation,
        'alIActivationAutoMaintienRX',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>
}

<app-label-description
  [description]="'P00080.installation.regulation.description' | translate"
></app-label-description>

<app-label-configuration
  [title]="'P00080.installation.misenoeuvreph.regulation' | translate"
  [titleListe]="
    'P00080.installation.misenoeuvreph.regulation.redox' | translate
  "
  [value]="actionStack!.getValue('alCConsignePh')"
  [liste]="P00080ConsignPH()"
  [information]="P00080InstallationPh"
  (onPress)="
    actionStack!.editValue(
      P00039DataRxTxIndex.Altimeo_Control,
      'alCConsignePh',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

@if (
  hasProduitP0003600() > 0 ||
  hasProduitP0003601() > 0 ||
  hasProduitP0004700() > 0 ||
  hasProduitP00046() > 0 ||
  hasProduitP00058() > 0 ||
  hasProduitP0006600() > 0
) {
  <app-switch-configuration
    [nameCustom]="'P00080.installation.filtrationph.value' | translate"
    [value]="actionStack!.getValue('alIActivationAutoMaintienPH') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Altimeo_Installation,
        'alIActivationAutoMaintienPH',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>
}

<app-label-description
  [description]="'P00080.installation.regulationph.description' | translate"
></app-label-description>
